import {FlowNodeData, FlowNodeTypes, SettingParamTypes} from "@/types/node";
import {Node} from "@xyflow/react";

export const rootNodeBlueprint: Partial<Node<FlowNodeData>> = {
  type: FlowNodeTypes.ROOT,
  id: "root",
  data: {
    type: FlowNodeTypes.ROOT,
    settingsTitle: "Conversation Settings",
    description: "This is the root node",
    isEmpty: true,
    onChange: () => {
      console.log("Start node changed");
    },
    settings: [],
  },
  position: {x: 0, y: 0},
};
